/* eslint-disable @typescript-eslint/no-explicit-any */
import type { ComponentProps, ComponentType } from 'react'
import MainBanner from 'src/components/sections/campaign/MainBanner'
import TextBlock from 'src/components/sections/campaign/TextBlock'
import InfoBanner from 'src/components/sections/campaign/InfoBanner'
import CollectionShelfv2 from 'src/components/restructure/product/shelves/CollectionShelfV2'
import BigNumbers20 from 'src/components/campanha_2.0/BigNumbers_2.0'
import SegmentationCarousel from 'src/components/campanha_2.0/segmentationCarousel'
import SegmentationCarouselWithImage from 'src/components/campanha_2.0/segmentationCarouselWithImage'
import CardTextual20 from 'src/components/campanha_2.0/CardTextual_2.0'
import EditorialCards20 from 'src/components/campanha_2.0/EditorialCards_2.0'
import SeoEditorial20 from 'src/components/campanha_2.0/SeoContentAndFaq_2.0'
import TechnicalContent20 from 'src/components/campanha_2.0/TechnicalContent_2.0'
import FeaturedProducts from 'src/components/sections/campaign/FeaturedProducts'

import BannerHighlight from '../sections/campaign/BannerHighlight'
import BannerDepartments from '../sections/campaign/BannerDepartments'
import PromotionBanner from '../sections/LP/PromotionBanner'
import ProductCarrosel from '../sections/LP/ProductCarrosel'
import DoubleBannerPromotion from '../sections/LP/DoubleBannerPromotion'
import { BlackFridayCountdown } from '../home/BlackFridayCountdown'
import CampaignForm from '../sections/campaign/Form/CampaignForm'
import { BannerFull } from '../department/BannerFull'
import { Pictos, PictosV2 } from '../common/Pictos'
import {
  CollectionBanner,
  CollectionBannerV2,
} from '../sections/CollectionBanner'
import GenericShelfv2 from '../restructure/product/shelves/GenericShelfV2'
import InsuranceMainBannerSectionData from '../sections/LP/LP-BikeInsurance/InsuranceMainBannerSectionData'
import InsuranceSectionBenefitStep from '../sections/LP/LP-BikeInsurance/InsuranceSectionBenefitStep'
import InsuranceSectionBenefitBanner from '../sections/LP/LP-BikeInsurance/InsuranceSectionBenefitBanner'
import InsuranceSectionClubSantuu from '../sections/LP/LP-BikeInsurance/InsuranceSectionClubSantuu'
import InsuranceSectionBannerGrid from '../sections/LP/LP-BikeInsurance/InsuranceSectionBannerGrid'
import InsuranceSectionTablePrices from '../sections/LP/LP-BikeInsurance/InsuranceSectionTablePrices'
import InsuranceSantuuFooter from '../sections/LP/LP-BikeInsurance/InsuranceSantuuFooter'
import CartaoPresenteMainBannerSectionData from '../sections/LP/LP-CartaoPresente/CartaoPresenteMainBannerSectionData'
import CartaoPresenteBenefitsSectionData from '../sections/LP/LP-CartaoPresente/CartaoPresenteBenefitsSectionData'
import CartaoPresenteHighlight from '../sections/LP/LP-CartaoPresente/CartaoPresenteHighlightSectionData'
import CartaoPresenteHowItWorks from '../sections/LP/LP-CartaoPresente/CartaoPresenteHowItWorksSectionData'
import CartaoPresenteBannerWithCards from '../sections/LP/LP-CartaoPresente/CartaoPresenteBannerWithCardsSectionData'
import CartaoPresenteInfo from '../sections/LP/LP-CartaoPresente/CartaoPresenteInfoSectionData'
import CartaoPresenteCorporate from '../sections/LP/LP-CartaoPresente/CartaoPresenteCorporateSectionData'
import FaqSection from '../sections/LP/LP-CartaoPresente/CartaoPresenteFaqSectionData'
import BenefitsGrid from '../ClubComponents/BenefitsGrid/BenefitsGrid'
import BenefitsSlideImg from '../ClubComponents/BenefitsSlideImg'
import TableTiersClub from '../ClubComponents/TableTiersClub/TableTiersClub'
import StarterKitBanner from '../StarterKit/StarterKitBanner'
import { DyPersonalizedContent } from '../home/DyPersonalizedContent/DyPersonalizedContent'
import { SphereContent } from '../restructure/product/sections/SphereContent'
import { KitlookCMSWrapper } from '../KitlookWidget/KitlookCMSWrapper'
import { BannerMood } from '../department/BannerMood'
import GridBanner from '../home/GridBanner'
import { NavigateBySports } from '../department/NavigateBySports'
import { NavigateByCategories } from '../department/NavigateByCategories'
import TertiaryBanner from '../home/TertiaryBanner'
import { InspiringShowcase } from '../sections/InspiringShowcase'
import RevampStorefront from '../revampStorefront'
import PageBackground_20 from '../campanha_2.0/PageBackground_2.0'
import CampaignBanner from '../campaignBanner'
import { Title } from '../campanha_2.0/Title_2.0'
import { HTMLContent } from '../campanha_2.0/HTMLContent_2.0'
import RealStories20 from '../campanha_2.0/RealStories_2.0'
import VitrineLarge from '../campanha_2.0/VitrineLarge'
import GridCategories20 from '../campanha_2.0/GridCategories_2.0'
import BannerProductInfos from '../bannerProductInfos'
import BannerProductTabs from '../bannerProductTabs'

function InspiringShowcaseWithoutStatsigGate(
  props: ComponentProps<typeof InspiringShowcase>
) {
  return <InspiringShowcase {...props} ignoreStatsigGate />
}

const COMPONENTS: Record<string, ComponentType<any>> = {
  'Banner Principal': MainBanner,
  'Bloco de Texto': TextBlock,
  'Banner Destaque': BannerHighlight,
  'Banner informativo': InfoBanner,
  'Carrossel de departamentos': BannerDepartments,
  'Banner de Promoções': PromotionBanner,
  'Carrossel de produtos': ProductCarrosel,
  'Banner duplo de promoções': DoubleBannerPromotion,
  'Vitrine Editorial [Home]': CollectionShelfv2,
  'Vitrine Editorial [Campanha]': CollectionShelfv2,
  '[Campanha] Produtos em Destaque _2.0': FeaturedProducts,
  'Vitrine DY [Departamento]': GenericShelfv2,
  'Vitrine DY [LP]': GenericShelfv2,
  'Vitrine DY [Colecao]': GenericShelfv2,
  'BlackFriday Countdown': BlackFridayCountdown,
  'Formulario [Campanha]': CampaignForm,
  ' Banner Full [Departamento]': BannerFull,
  ' Pictos v2 [Departamento] ': PictosV2,
  ' Pictos [Departamento]': Pictos,
  '[Coleção] Banner V2': CollectionBannerV2,
  '[Coleção] Banner': CollectionBanner,
  '[Seguro Bike] Banner Principal': InsuranceMainBannerSectionData,
  '[Seguro Bike] Benefícios em etapas': InsuranceSectionBenefitStep,
  '[Seguro Bike] Banner benefícios': InsuranceSectionBenefitBanner,
  '[Seguro Bike] Clube Santuu': InsuranceSectionClubSantuu,
  '[Seguro Bike] Banner + Grid': InsuranceSectionBannerGrid,
  '[Seguro Bike] Tabela de Preços': InsuranceSectionTablePrices,
  '[Seguro Bike] Footer Santuu': InsuranceSantuuFooter,
  '[Cartao Presente] Banner Principal': CartaoPresenteMainBannerSectionData,
  '[Cartao Presente] Benefícios': CartaoPresenteBenefitsSectionData,
  '[Cartao Presente] Destaque': CartaoPresenteHighlight,
  '[Cartao Presente] Como Funciona': CartaoPresenteHowItWorks,
  '[Cartao Presente] Banner + Cards': CartaoPresenteBannerWithCards,
  '[Cartão Presente] Info': CartaoPresenteInfo,
  '[Cartao Presente] Corporate': CartaoPresenteCorporate,
  '[Cartão Presente] - FAQ': FaqSection,
  '[Clube] Benefícios em Slide': BenefitsSlideImg,
  '[Clube] Mosaico de Benefícios': BenefitsGrid,
  '[Clube] Lista de Níveis': TableTiersClub,
  '[Starter Kit] Banner Principal': StarterKitBanner,
  '[Home] Dy Conteúdo Personalizado': DyPersonalizedContent,
  '[Sphere] Sphere ID': SphereContent,
  '[Kitlook] Widget Kitlook': KitlookCMSWrapper,
  ' Banners Mood [Departamento]': BannerMood,
  'Banners Secundários [Home]': GridBanner,
  'Navegue por esporte [Departamento]': NavigateBySports,
  'Navegue por categoria [Departamento]': NavigateByCategories,
  'Banners Terciários [Home]': TertiaryBanner,
  '[Departamento | Campanha] Vitrine Inspiracional':
    InspiringShowcaseWithoutStatsigGate,
  '[Campanhas 2.0] Vitrine Editorial Comercial': RevampStorefront,
  '[Campanha 2.0] Cor de fundo da página': PageBackground_20,
  '[Campanhas 2.0] Historias Reais': RealStories20,
  '[Campanhas 2.0] Vitrine Large': VitrineLarge,
  '[Departamento | Campanha] Vitrine com Tabs': BannerProductTabs,
  '[Campanhas 2.0] Big Numbers': BigNumbers20,
  '[Campanhas 2.0] Carrossel de Segmentação sem Imagem': SegmentationCarousel,
  '[Campanhas 2.0] Carrossel de Segmentação com Imagem':
    SegmentationCarouselWithImage,
  '[Campanhas 2.0] Card Textual': CardTextual20,
  '[Campanhas 2.0] Conteúdo Técnico': TechnicalContent20,
  '[Campanhas 2.0] Grid de Categorias': GridCategories20,
  '[Campanhas 2.0] Cards com CTA': EditorialCards20,
  '[Campanhas 2.0] Conteúdo SEO & FAQ': SeoEditorial20,
  '[Campanha] Banner': CampaignBanner,
  '[Campanhas 2.0] Title': Title,
  '[Campanhas 2.0] HTML livre': HTMLContent,
  '[LP] Informações do Produto': BannerProductInfos,
}

interface Props {
  sections?: Array<{ name: string; data: any }>
}

function RenderPageSections({ sections }: Props) {
  return (
    <>
      {sections?.map(({ name, data }, index) => {
        const Component = COMPONENTS[name]

        if (!Component) {
          console.info(
            `Could not find component for block ${name}. Add a new component for this block or remove it from the CMS`
          )

          return <></>
        }

        return (
          <Component
            key={`cms-section-${name}-${index}`}
            {...{ ...data, section: name }}
          />
        )
      })}
    </>
  )
}

export default RenderPageSections
